module.exports = "data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAAAQAwCdASoZABkAPpFCnEolo6KhqAgAsBIJZwC/7BanFAAA/vb56g+Mng59/gp9AAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/butter_cream.webp
// module id = ouV/
// module chunks = 14